import { API_BASE_URL } from "src/config/api";
import { useState } from 'react';
import {
    Button,
    Popover,
    TextField,
    Typography,
    IconButton,
    CircularProgress
} from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';

import Iconify from '../../../components/iconify';

export default function HelpPopover() {
    const [open, setOpen] = useState(null);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);


    const handleOpen = (event) => setOpen(event.currentTarget);
    const handleClose = () => setOpen(null);

    const handleSubmit = async () => {
        if (!message.trim()) return;

        setLoading(true);
        const userId = localStorage.getItem('userId');
        
        if (!userId) {
            toast.error('User ID not found. Please refresh or log in again.');
            setLoading(false);
            return;
        }

        try {
            const apiUrl = `${API_BASE_URL}/helpForm`;
            const response = await axios.post(apiUrl, { userId, message });

            if (response.status === 200) {
                toast.success('Thanks for reaching out! Our team will get back to you shortly.');
                setMessage('');
                handleClose();
            } else {
                toast.error('Failed to submit your message. Please try again.');
            }

        } catch (err) {
            console.error('Help form error:', err);
            toast.error('Failed to submit your message. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <IconButton color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
                <Iconify icon="fluent:person-support-20-filled" width={40} height={40} />
            </IconButton>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ sx: { mt: 1.5, ml: 0.75, width: 360, p: 2 } }}
            >
                <Typography variant="h6" gutterBottom>
                    Need Help?
                </Typography>

                <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    placeholder="Describe your issue or ask a question..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    inputProps={{ maxLength: 200 }}
                />
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    {message.length}/200 characters
                </Typography>

                <Button
                    variant="contained"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
                </Button>
            </Popover>
        </>
    );
}
